import { styled } from '@mui/material';
import React from 'react';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import { BrandclubVideo } from '../components/BrandclubVideo.js';

var HeaderContainer = styled(GenericContainer, {
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: fullWidth ? 0 : '5%',
            paddingRight: fullWidth ? 0 : '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(fullWidth ? 0 : MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var VideoContainer = styled('div', {
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c;
    return (_b = {
            maxWidth: fullWidth ? '100%' : DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {},
        _b);
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var LargeCenterVideo = function (_a) {
    var _b;
    var _c = _a.video, video = _c === void 0 ? '' : _c, _d = _a.coverImage, coverImage = _d === void 0 ? '' : _d, page = _a.page;
    var fullWidth = !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width);
    return (React.createElement(HeaderContainer, { fullWidth: fullWidth },
        React.createElement(VideoContainer, { fullWidth: fullWidth },
            React.createElement(BrandclubVideo, { videoUrl: video, posterUrl: coverImage }))));
};

export { LargeCenterVideo };
//# sourceMappingURL=index.js.map
